import React from "react";
import "./inside_uc.css";
import InfoBox from "../../common/infobox/Infobox";
import data from "../../../configs/inside-uc/insideuc.json";
import Carousel from "../../common/carousel/Carousel";

const InsideUc = () => {
  return (
    <div className="inside-uc" id="inside-uc">
      <div className="inside-uc-heading">Inside UC</div>
      <div className="engineering">Blogs</div>
      <div className="infobox-list section-1">
        {data.blogs.map((blog, index) => {
          return (
            <InfoBox
              title={blog.title}
              description={blog.description}
              link={blog.navigationLinks[0]}
              image={
                window.innerWidth <= 768
                  ? blog.imageLink.mobile
                  : blog.imageLink.web
              }
            />
          );
        })}
      </div>
      <div className="engineering">Featured – Tech & Design</div>
      <div className="infobox-list section-2">
        {window.innerWidth > 768 &&
          data.tech.map((tec) => {
            return (
              <InfoBox
                title={tec.title}
                description={tec.description}
                link={tec.navigationLinks[0]}
                image={tec.imageLink.web}
              />
            );
          })}
        {window.innerWidth <= 768 && (
          <Carousel
            width={343}
            items={1}
            size={data.tech.length}
            showArrow={true}
            showDot={true}
          >
            {data.tech.map((tec) => {
              return (
                <InfoBox
                  title={tec.title}
                  description={tec.description}
                  link={tec.navigationLinks[0]}
                  image={tec.imageLink.mobile}
                />
              );
            })}
          </Carousel>
        )}
      </div>
    </div>
  );
};

export default InsideUc;
